class Global {
    constructor() {
        this.init()
    }

    init () {
        this.cacheDOM()
        this.bindEvents()
        this.disableBtnOnSubmit()
    }

    cacheDOM () {
        this.$scoll_content = $( '[id^=lists_scroll_block_]' )
    }

    bindEvents () {

    }

    disableBtnOnSubmit () {
        var disableSubmit = false
        jQuery( '.wpcf7-submit[type="submit"]' ).click( function () {
            jQuery( '.wpcf7-submit[type="submit"]' ).text( "Sending..." )
            if ( disableSubmit == true ) {
                return false
            }
            disableSubmit = true
            return true
        } )

        const wpcf7Elm = document.querySelector( '.wpcf7' )

        if ( wpcf7Elm ) {
            wpcf7Elm.addEventListener( 'wpcf7mailsent', function ( event ) {
                jQuery( '.wpcf7-submit[type="submit"]' ).text( "Send" )
                disableSubmit = false
            }, false )

            wpcf7Elm.addEventListener( 'wpcf7invalid', function ( event ) {
                jQuery( '.wpcf7-submit[type="submit"]' ).text( "Send" )
                disableSubmit = false
            }, false )
        }
    }
}

new Global()
